// src/components/Websites/Websites.js
import React from 'react';
import { Helmet } from 'react-helmet-async';

import './Websites.css';
import WebsiteItem from './WebsiteItem';

import Website1 from "../Assets/websites/website1.jpg";
import Website2 from "../Assets/websites/website2.jpg";
import Website3 from "../Assets/websites/website3.jpg";

// Sample website data (replace with your actual websites)
const websiteData = [
  {
    id: 1,
    title: 'School Website',
    description: 'Next.js and Node.js',
    thumbnail: Website1,
    url: 'https://tatabuildingindia.com/',
  },
  {
    id: 2,
    title: 'Travell Website',
    description: 'React.js and PHP',
    thumbnail: Website2,
    url: 'https://airporttaxisbangalore.com',
  },
];

const Websites = () => {
  return (
    <>
      <Helmet>
        <title>Websites by Srihari Muppalla | Web Developer in Bangalore</title>
        <meta
          name="description"
          content="Discover responsive websites built by Srihari Muppalla, a skilled Web Developer in Bangalore, India. Specializing in modern web development with React.js, Node.js, Next.js, Express.js, HTML, CSS, and JavaScript."
        />
        <meta
          name="keywords"
          content="Srihari Muppalla, Web Developer, websites, Bangalore, India, responsive web design, React.js, Node.js, Next.js, Express.js, HTML, CSS, JavaScript"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Srihari Muppalla" />
        <link rel="canonical" href="https://sriharim.in/websites" />

        {/* Open Graph Tags */}
        <meta
          property="og:title"
          content="Websites by Srihari Muppalla | Web Developer in Bangalore"
        />
        <meta
          property="og:description"
          content="Discover responsive websites built by Srihari Muppalla, a skilled Web Developer in Bangalore, India. Specializing in modern web development with React.js, HTML, CSS, and JavaScript."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://sriharim.in/websites" />
        <meta property="og:image" content="https://sriharim.in/Logo.png" /> {/* Replace with a relevant image */}
        <meta property="og:image:alt" content="Websites by Srihari Muppalla" />
        <meta property="og:site_name" content="Srihari Muppalla Portfolio" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Websites by Srihari Muppalla | Web Developer in Bangalore"
        />
        <meta
          name="twitter:description"
          content="Discover responsive websites built by Srihari Muppalla, a skilled Web Developer in Bangalore, India. Specializing in modern web development with React.js, HTML, CSS, and JavaScript."
        />
        <meta name="twitter:image" content="https://sriharim.in/Logo.png" /> {/* Replace with a relevant image */}
        <meta name="twitter:image:alt" content="Websites by Srihari Muppalla" />
        <meta name="twitter:creator" content="@srihariM64" /> {/* Replace with your Twitter handle */}
      </Helmet>
      <div className="websites-container">
        <h1 className="websites-title">Websites</h1>
        <p className="websites-subtitle">
          Explore a collection of websites I've built, showcasing a variety of designs and functionalities tailored to different industries.
        </p>
        <div className="websites-grid">
          {websiteData.map((website) => (
            <WebsiteItem key={website.id} website={website} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Websites;